import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { ANIMATION_TYPES } from '@daedalus/atlas/Overlay';
import { OverlayPage, OverlayPageContent } from '@daedalus/atlas/OverlayPage';
import { PopUp } from '@daedalus/atlas/PopUp';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { Room, RoomWithoutOffers } from '@daedalus/core/src/room/types/room';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { RoomDetailsOverlayContent } from './RoomDetailsOverlayContent';
interface Props {
  isOpen: boolean;
  isRtl?: boolean;
  room: Room | RoomWithoutOffers;
  imageProvider: ImageProvider;
  onGallerySwipe?: () => void;
  onClose: () => void;
  roomCardSlot?: React.ReactNode;
  stickyFooterSlot?: React.ReactNode;
  userCountry: string;
}
const DesktopOverlayWrapper = /*#__PURE__*/styled('div')({
  name: "DesktopOverlayWrapper",
  class: "dcjyxr4",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => PopUp;
const StyledPopUp = /*#__PURE__*/styled(_exp())({
  name: "StyledPopUp",
  class: "s7y11ci",
  propsAsIs: true
});
export const RoomDetailsOverlay = ({
  isOpen,
  isRtl = false,
  room,
  imageProvider,
  onGallerySwipe,
  onClose,
  roomCardSlot = null,
  stickyFooterSlot = null,
  userCountry
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  const content = () => <RoomDetailsOverlayContent room={room} isRtl={isRtl} imageProvider={imageProvider} onGallerySwipe={onGallerySwipe} roomCardSlot={roomCardSlot} userCountry={userCountry} />;
  const Title = () => <FormattedMessageWrapper id="roomDetails" defaultMessage="Room details" />;
  return <>
      {isMobile ? <OverlayPage onClose={onClose} isOpen={isOpen} titleBarProps={{
      centerContent: <Title />
    }} animationType={ANIMATION_TYPES.NONE}>
          <OverlayPageContent>
            {content()}
            {stickyFooterSlot}
          </OverlayPageContent>
        </OverlayPage> : <StyledPopUp noPaddings isOpen={isOpen} closeAction={onClose} titleBarProps={{
      centerContent: <Title />
    }} width={640}>
          <DesktopOverlayWrapper>{content()}</DesktopOverlayWrapper>
        </StyledPopUp>}
    </>;
};

require("./RoomDetailsOverlay.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomDetailsOverlay.tsx");